module.exports = __webpack_public_path__ + "static/media/calendar.39937fc3.svg";